module.exports = "/assets/data/327b5dcc132c6e9dc051ab40b4ed84a1-SK5.data.json";